// Words on the signer's page (AGREESIGN, R19). The signer is a practitioner
// or physician the practice sent a link to; they have no VerityRx sign-in.
export const SIGN_TITLE = 'Sign your agreement';
export const SIGN_LOADING = 'Opening your agreement…';
export const SIGN_FOR = (name: string) => `For ${name}`;
export const SIGN_LEAD =
  'Read the agreement below. When you are ready, confirm that you agree to sign electronically and type your full name.';
export const SIGN_PARTIES = (practitioner: string, physician: string) =>
  `Between ${practitioner} and ${physician}.`;
export const SIGN_STARTS = (date: string) => `Starts ${date}.`;
export const SIGN_ENDS = (date: string | null) => (date ? `Ends ${date}.` : 'No end date.');
export const SIGN_MEDICATIONS = 'Medications it covers';
export const SIGN_OPEN_DOCUMENT = 'Open the agreement';
export const SIGN_DOCUMENT_FRAME = 'The agreement';
export const SIGN_FINGERPRINT = 'Document fingerprint';
export const SIGN_ALREADY = 'You have already signed this one.';
export const SIGN_CLOSED = 'This agreement is no longer open for signing.';
export const SIGN_CONSENT_LABEL = 'I agree to sign electronically';
export const SIGN_NAME = 'Type your full name';
export const SIGN_NAME_HINT = (name: string) => `As the practice has it: ${name}`;
export const SIGN_SUBMIT = (n: number) => (n === 1 ? 'Sign the agreement' : `Sign all ${n} agreements`);
export const SIGN_DONE_TITLE = 'Signed';
export const SIGN_DONE_BODY =
  'Thank you. The practice now has your signature. When every party has signed, the signed copy with its signature certificate is stored with the practice. You can close this page.';
export const SIGN_EXPIRES = (date: string) => `This link works once, until ${date}.`;
export const SIGN_NO_LINK = 'This page needs the signing link the practice sent you.';
export const SIGN_TROUBLE = 'Questions about the agreement? Contact the practice that sent you the link.';
export const SIGN_ERROR = 'Something went wrong. Try again in a moment.';
